<template>
    <birth-form :birth="birth" @processBirth="addBirth"></birth-form>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";
import BirthForm from "@/components/Births/BirthForm";
export default {
  components: {
    BirthForm
  },
  data() {
    return {
      birth: {
        child_name: "",
        child_lastname: "",
        is_public: true,
        selected: true,
        birthday: new Date().toISOString().substr(0, 10),
        full_name_father: "",
        full_name_mother: "",
        approved: true,
        user_id: ""
      }
    };
  },
  methods: {
    ...mapActions({
      createBirth: "births/addBirth"
    }),
    addBirth(birth) {
      this.createBirth(birth).then(() => {
        this.$router.push("/celebremos-nacimientos");
      });
    }
  }
};
</script>
